import React, { useState, useEffect } from 'react';

const messages = [
  'Inviando messaggio...',
  'Attendere...',
  'Elaborando...',
  'In attesa di risposta...',
];

function AnimatedStatus() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (index >= messages.length - 1) return;

    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => prev + 1);
        setFade(true);
      }, 300);
    }, 2500);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(interval);
    };
  }, [index]);

  return (
    <div className="bg-success text-white bg-opacity-75 border px-3 py-2 rounded w-50 ms-auto my-2 d-flex align-items-center justify-content-center gap-2">
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p
        className={`m-0 transition-opacity ${fade ? 'opacity-100' : 'opacity-0'}`}
        style={{ transition: 'opacity 0.3s ease' }}
      >
        {messages[index]}
      </p>
    </div>
  );
}

export default AnimatedStatus;
